"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "~/components/ui/button";
import { api, getBaseUrl } from "~/trpc/react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Heart, Link as LinkIcon, Loader, Twitter } from "lucide-react";
import { toast } from "sonner";
export const ArticleActionbar = t0 => {
  const $ = _c(39);
  const {
    article
  } = t0;
  let t1;
  if ($[0] !== article.articleId) {
    t1 = {
      articleId: article.articleId
    };
    $[0] = article.articleId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [data, t2] = api.user.checkFavorite.useSuspenseQuery(t1);
  const {
    isFetching,
    refetch
  } = t2;
  let t3;
  if ($[2] !== refetch) {
    t3 = {
      onSuccess: () => void refetch(),
      onError: _temp
    };
    $[2] = refetch;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const yeuThich = api.user.toggleFavorite.useMutation(t3);
  const tweetUrl = new URL("https://x.com/intent/tweet");
  const currentPath = usePathname();
  tweetUrl.searchParams.set("text", article.title);
  tweetUrl.searchParams.set("url", getBaseUrl() + currentPath);
  const t4 = "flex max-w-[800px] items-center justify-between pt-4";
  const t5 = data?.status === "not-signed-in" ? "\u0110\u0103ng nh\u1EADp \u0111\u1EC3 th\xEDch b\xE0i vi\u1EBFt" : "Y\xEAu th\xEDch b\xE0i vi\u1EBFt";
  const t6 = yeuThich.isPending || isFetching || data?.status === "not-signed-in";
  let t7;
  if ($[4] !== article.articleId || $[5] !== data || $[6] !== yeuThich) {
    t7 = () => {
      if (typeof data !== "undefined") {
        yeuThich.mutate({
          articleId: article.articleId,
          isFavorited: data.status === "favorited"
        });
      }
    };
    $[4] = article.articleId;
    $[5] = data;
    $[6] = yeuThich;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== data || $[9] !== isFetching || $[10] !== yeuThich.isPending) {
    t8 = isFetching || yeuThich.isPending ? <Loader size={20} className="animate-spin" /> : <Heart size={20} className={data.status === "favorited" ? "fill-red-600 stroke-red-600" : undefined} />;
    $[8] = data;
    $[9] = isFetching;
    $[10] = yeuThich.isPending;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = <div className="flex gap-2"><Button size="icon" variant="outline" title={t5} disabled={t6} onMouseDown={t7}>{t8}</Button></div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = "flex items-center gap-2";
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span> Chia sẽ:</span>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const T0 = Button;
  const t12 = "rounded-r-none";
  const t13 = "outline";
  const t14 = "Chia s\u1EBD b\u1EA3n tin n\xE0y l\xEAn X";
  const T1 = Link;
  const t15 = tweetUrl.toString();
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Twitter size={20} />;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== T1 || $[20] !== t15) {
    t17 = <T1 href={t15} target="_blank">{t16}</T1>;
    $[19] = T1;
    $[20] = t15;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== T0 || $[23] !== t17) {
    t18 = <T0 className={t12} variant={t13} title={t14}>{t17}</T0>;
    $[22] = T0;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== currentPath) {
    t19 = () => {
      toast.promise(window.navigator.clipboard.writeText(getBaseUrl() + currentPath), {
        success: "Sao ch\xE9p \u0111\u01B0\u1EDDng d\u1EABn th\xE0nh c\xF4ng",
        error: "Sao ch\xE9p \u0111\u01B0\u1EDDng d\u1EABn th\u1EA5t b\u1EA1i"
      });
    };
    $[25] = currentPath;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <LinkIcon size={20} />;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t19) {
    t21 = <Button className="rounded-l-none" variant="outline" title={"Sao ch\xE9p \u0111\u01B0\u1EDDng d\u1EABn c\u1EE7a b\u1EA3n tin n\xE0y"} onMouseDown={t19}>{t20}</Button>;
    $[28] = t19;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== t18 || $[31] !== t21) {
    t22 = <div>{t18}{t21}</div>;
    $[30] = t18;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== t11 || $[34] !== t22) {
    t23 = <div className={t10}>{t11}{t22}</div>;
    $[33] = t11;
    $[34] = t22;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t23 || $[37] !== t9) {
    t24 = <div className={t4}>{t9}{t23}</div>;
    $[36] = t23;
    $[37] = t9;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  return t24;
};
function _temp(t0) {
  const {
    message
  } = t0;
  return toast.error("L\u1ED7i: " + message);
}